import { getTransformedDate } from './date-helpers'
import { AdminSaleOffer, AdminSaleOfferFilterState, AdminSaleOfferGroup, Currency, UserSaleOffer } from '../models'

export const getFilteredUserSaleOffers = (
  filterText: string, bigList: UserSaleOffer[], currencyList: Currency[]
): UserSaleOffer[] => {

  let newOffers = bigList

  if (filterText) {
    const text = filterText.toLowerCase()
    newOffers = newOffers.filter((offer: UserSaleOffer)=> {
      const currencyCode = currencyList.find(c => c.id === offer.currency)?.code
      return (
        offer.project_name.toLowerCase().includes(text) ||
        `${offer.vintage_year}`?.toLowerCase().includes(text) ||
        `${offer.price_per_unit}`?.toLowerCase().includes(text) ||
        `${offer.total}`?.toLowerCase().includes(text) ||
        offer.status.toLowerCase().includes(text) ||
        currencyCode?.toLowerCase().includes(text) ||
        getTransformedDate(offer.expiration_date)?.toLowerCase().includes(text) ||
        `${offer.total}`?.toLowerCase().includes(text)
      )
    })
  }
  return newOffers
}

export const getFilteredOfferSaleGroups = (
  filterText: string, bigList: AdminSaleOfferGroup[]
): AdminSaleOfferGroup[] => {
  let newGroups = bigList

  if (filterText) {
    const text = filterText.toLowerCase()
    newGroups = newGroups.filter((group: AdminSaleOfferGroup)=> {
      return (
        group.name.toLowerCase().includes(text) ||
        group.sale_offers?.some(offer => offer.project_name?.toLocaleLowerCase().includes(text)) ||
        group.sale_offers?.some(offer => offer.client_email?.toLocaleLowerCase().includes(text)) ||
        group.sale_offers?.some(offer => offer.sales_agent_email?.toLocaleLowerCase().includes(text))
      )
    }).map(group => {
      const newSaleOffers = group.sale_offers.filter(offer => {
        return (
          offer.client_email?.toLocaleLowerCase().includes(text) ||
          offer.sales_agent_email?.toLocaleLowerCase().includes(text) ||
          offer.project_name?.toLocaleLowerCase().includes(text)
        )
      })
      return { ...group, sale_offers: newSaleOffers }
    })
  }
  return newGroups
}

export const getAdminSaleOffersFiltered = (
  filters: AdminSaleOfferFilterState, bigList: AdminSaleOffer[]
): AdminSaleOffer[] => {
  let newList = bigList

  if (filters.text) {
    const text = filters.text.toLocaleLowerCase()
    newList = newList.filter(offer => {
      return (
        offer.client_email?.toLocaleLowerCase().includes(text) ||
        offer.project_name?.toLocaleLowerCase().includes(text) ||
        offer.sales_agent_email?.toLocaleLowerCase().includes(text)
      )
    })
  }

  if (filters.status !== 'all') {
    newList = newList.filter(offer => offer.status === filters.status)
  }

  return newList
}



export const convertSaleOfferIntoUserSaleOffer = (offer: AdminSaleOffer): UserSaleOffer => {
  return {
    allow_counter_offer: false,
    ...offer
  }
}
